import React from 'react'

import OverlayStyled from './styles'

export default function Overlay (props) {
  if (!props.open) return null;
  return (
    <OverlayStyled>
      {props.children}
    </OverlayStyled>
  )
}